import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Modal} from 'shells/modal/modal';
import {OnboardingPage} from 'shells/onboarding-page/onboarding-page';

import {HelpBodyUserAssignment} from './help-body-user-assignment';
import {HelpGraphicUserAssignment} from './help-graphic-user-assignment';

type Props = {
    onClose: () => void;
    isOpen: boolean;
};

export class HelpUserAssignment extends React.PureComponent<Props> {
    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.isOpen}
                    noPadding={true}
                    onClose={this.props.onClose}
                    closeButton={false}
                    preventBodyScroll={false}
                    maxHeight={500}
                >
                    <OnboardingPage
                        type='singlePage'
                        bodyComponent={<HelpBodyUserAssignment />}
                        artBackgroundColor={colors.plumDk}
                        artImage={<HelpGraphicUserAssignment />}
                        buttonText='Done'
                        onClose={this.props.onClose}
                    />
                </Modal>
            </div>
        );
    }
}
